import { useAuth0 } from '@auth0/auth0-react';
import { clearSelectedOrgFromStorage } from '@/pages/OrgSwitcher/utils';
import { loggedOut } from '@/redux/slices/loggedUserSlice';
import { useAppDispatch, useAppSelector } from '@/redux/store';

/**
 * Hook to handle user logout.
 *
 * This hook provides a logout function that:
 * - Dispatches the loggedOut action to clear Redux state
 * - Handles ADP SSO logout if the user is logged in via ADP
 * - Redirects to the appropriate logout URL
 */
export function useLogout() {
  const dispatch = useAppDispatch();
  const { logout } = useAuth0();
  const loggedUser = useAppSelector(state => state.loggedUser);

  const handleLogout = () => {
    dispatch(loggedOut());
    clearSelectedOrgFromStorage();

    const encodedRedirectUri = encodeURIComponent(window.location.origin);
    const adpLogoutUrl = `https://accounts.adp.com/auth/oauth/v2/logout?post_logout_redirect_uri=${encodedRedirectUri}`;

    const adpSSOLoggedIn = loggedUser?.adp_sso_login ?? false;

    logout({
      logoutParams: {
        returnTo: adpSSOLoggedIn ? adpLogoutUrl : window.location.origin,
      },
    });
  };

  return handleLogout;
}
